import { BucketedData } from '../fillsGraphDataBuckets';
import { PercentageOfMarketVolumeData } from './PercentageOfMarketVolumeChart';

export function getChartData(
    bucketedData: BucketedData[],
    timeCompleted: number | undefined,
    intervalToWidth: (fromInterval: number) => number
): PercentageOfMarketVolumeData[] {
    const firstBucketWithFill = bucketedData.find((b) =>
        b.fillVolume ? b.fillVolume > 0 : false
    );

    const bucketsFromFirstWithFill = bucketedData.filter((d) =>
        firstBucketWithFill
            ? d.startTime >= firstBucketWithFill.startTime
            : true
    );

    const bucketsUpToTimeCompleted = timeCompleted
        ? bucketsFromFirstWithFill.filter(
              (b) =>
                  b.endTime <= timeCompleted ||
                  (b.startTime <= timeCompleted && b.endTime >= timeCompleted)
          )
        : bucketsFromFirstWithFill;

    return bucketsUpToTimeCompleted.map((b) => ({
        midTime: b.midTime,
        percentOfMarketVolume: b.percentOfMarketVolume,
        averagePercentOfMarketVolume: b.averagePercentOfMarketVolume,
        bucketWidth: intervalToWidth(b.endTime - b.startTime),
    }));
}
